"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currencies = [
    {
        id: 'CAD',
        name: 'Canadian Dollar',
        symbol: '$',
    },
    {
        id: 'EUR',
        name: 'Euro',
        symbol: '€',
    },
    {
        id: 'GBP',
        name: 'Pound Sterling',
        symbol: '£',
    },
    {
        id: 'HKD',
        name: 'Hong Kong Dollar',
        symbol: '$',
    },
    {
        id: 'USD',
        name: 'US Dollar',
        symbol: '$',
    },
];
exports.default = currencies;
